import { Component, ContentChildren, Directive, InjectionToken, OnInit, QueryList, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';

export const ENT_RADIO_GROUP =
  new InjectionToken<EntRadioGroup>('EntRadioGroup');

export const ENT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => EntRadioGroup),
  multi: true
};

@Directive({
  standalone: false,
  selector: 'ent-radio-group',
  exportAs: 'entRadioGroup',
  providers: [
    ENT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR,
    { provide: ENT_RADIO_GROUP, useExisting: EntRadioGroup },
  ],
  host: {
    'role': 'radiogroup',
    'class': 'ent-radio-group',
  },
})

export class EntRadioGroup implements ControlValueAccessor {
  @ContentChildren(forwardRef(() => MatRadioButton), { descendants: true })
  _radios!: QueryList<EnactRadioButtonComponent>;

  private _value: any;
  private _onChange: (value: any) => void = () => {};
  private _onTouched: () => void = () => {};

  get value(): any {
    return this._value;
  }

  set value(val: any) {
    this._value = val;
    this._onChange(val);
  }

  writeValue(value: any): void {
    this._value = value;
    if (this._radios) {
      this._radios.forEach(radio => {
        radio.checked = radio.value === value;
      });
    }
  }

  registerOnChange(fn: (value: any) => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this._radios) {
      this._radios.forEach(radio => {
        radio.disabled = isDisabled;
      });
    }
  }
}

@Component({ standalone: false,
  selector: 'enact-radiobutton',
  templateUrl: './enact-radio-button.component.html',
  styleUrls: ['./enact-radio-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EnactRadioButtonComponent),
      multi: true
    }],
    host: {
      'class': 'enact-radio-button',
      '[class.enact-radio-checked]': 'checked',
      '[class.enact-radio-disabled]': 'disabled',
      '[attr.tabindex]': 'null',
      '[attr.id]': 'id',
    }
})

export class EnactRadioButtonComponent extends MatRadioButton implements OnInit, ControlValueAccessor {

  model: any;
  onTouched: any;
  onChange: any;
  internalValue: any;

  onModelChange(value: any) {
    this.checked = value;
    this.onTouched(value);
    this.onChange(value);
  }

  writeValue(obj: any): void {
    this.internalValue = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit(): void {
    // console.log('-----RadiobuttonComponent extends MatRadioButton--->>>', this.inputId)
  }

}